import React, { FC } from 'react'

const ClashIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 36 34"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M17.5 0L35 33H0L17.5 0Z M17.5 5L3 30H32L17.5 5Z M16 21V13H19V21H16Z M16 25V22H19V25H16Z" />
    </svg>
)

export default ClashIcon
